import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
import { executeFunction, executeObjectExpr, isArrayNotEmpty, } from '@/common/util/util';
import { __arrayTableCurrentRow__ } from '@/common/util/expr-const';
import groupBy from 'lodash/groupBy';
export const config = {
    value: 'setFormFieldState',
    position: ALL_BUTTON_POSITION_LIST,
    action: (config) => {
        const { buttonConfig, state, _context, field } = config || {};
        const { options } = buttonConfig || {};
        const { _bindForm, fieldStateList, handleType, batchSetFieldFieldCallback, } = options || {};
        if (_bindForm) {
            const formNode = _context?.$(_bindForm);
            const formInstance = formNode?.getFormInstance?.();
            if (formInstance) {
                if (handleType === 'batchSetField') {
                    if (typeof batchSetFieldFieldCallback === 'function') {
                        executeFunction(batchSetFieldFieldCallback, {
                            form: formInstance,
                            state,
                        });
                    }
                }
                else if (isArrayNotEmpty(fieldStateList)) {
                    const groupFieldState = groupBy(fieldStateList, 'label');
                    for (const key in groupFieldState) {
                        const stateList = groupFieldState[key];
                        let realKey = key;
                        if (key && isArrayNotEmpty(stateList)) {
                            if (key?.includes(__arrayTableCurrentRow__) && field) {
                                const arr = key?.split?.(`.${__arrayTableCurrentRow__}.`);
                                if (arr.length === 2) {
                                    const fieldName = arr[0];
                                    const arrayTableFieldName = arr[1];
                                    const segments = field?.path?.segments || [];
                                    const fieldIndex = +segments[segments?.length - 2];
                                    if (!isNaN(fieldIndex)) {
                                        realKey = `${fieldName}.${fieldIndex}.${arrayTableFieldName}`;
                                    }
                                }
                            }
                            formInstance.setFieldState(realKey, (fieldState) => {
                                stateList.forEach((item) => {
                                    const { value, state: _state } = item;
                                    if (value && _state !== undefined) {
                                        fieldState[value] = executeObjectExpr(_state, {}, {}, _context?.state);
                                    }
                                });
                            });
                        }
                    }
                }
            }
        }
        return Promise.resolve();
    },
};
